// extracted by mini-css-extract-plugin
module.exports = {"nav":"header-back_nav__3LXBn","nav_back":"header-back_nav_back__2XN5j","nav_back_icon":"header-back_nav_back_icon__1V9Hb"};